import React, { ComponentProps } from 'react'

import { styled } from 'nativewind'

import { Icon } from '../icons'
import { Stack, XStack } from '../layout'
import Pressable from '../pressable'
import { colors } from '../tailwind'
import { B2, BTN, Text } from '../typography'

const SingleSidedShadowBox = styled(Stack, 'overflow-hidden p-[1px] rounded')

const ToastContainer = styled(
  XStack,
  ' rounded border-l-4 bg-white p-[12px] elevation-md w-full',
  {
    variants: {
      intent: {
        error: 'border-l-error-100',
        success: 'border-l-success-100 ',
        warning: 'border-l-warning-100',
      },
    },
    defaultProps: {
      intent: 'success',
    },
  }
)

const ToasterLogoContainer = styled(XStack, 'flex-grow')

const MessageContainer = styled(Stack, 'ml-2.5 mr-2 flex flex-1')
const MessageIcon = styled(Icon, '')
const MessageHeading = styled(B2, ' text-grays-80 ')
const MessageDescription = styled(Text, ' text-xs ')

type ToastFrameProps = ComponentProps<typeof ToastContainer>

type ToastProps = ToastFrameProps & {
  intent: string
  messageHeading: string
  messageDescription: string
  iconSize?: number
  actionButton?: React.ReactNode
  onClosePress?: () => void
  action?: {
    text: string
    onPress?: () => void
  }
  rightComponent?: JSX.Element | null
  leftIcon?: string
}

export function Toast({
  intent,
  messageHeading,
  messageDescription,
  onClosePress,
  action,
  rightComponent,
  leftIcon,
  ...props
}: ToastProps) {
  const { type, color } =
    intent === 'error'
      ? { type: 'ErrorOutlined', color: colors.error[100] }
      : intent === 'success'
      ? { type: leftIcon || 'DoneOutlined', color: colors.success[100] }
      : { type: 'CautionOutlined', color: colors.warning[100] }
  console.log(messageDescription + '  d')
  return (
    <SingleSidedShadowBox {...props}>
      <ToastContainer intent={intent}>
        <ToasterLogoContainer style={{ flex: 1, alignItems: 'center' }}>
          <Stack>
            <MessageIcon
              type={type}
              color={color}
              size={props.iconSize || 24}
            />
          </Stack>
          <MessageContainer>
            <MessageHeading
              style={{
                fontWeight: messageDescription ? '800' : '600',
              }}
            >
              {messageHeading}
            </MessageHeading>
            {messageDescription && (
              <MessageDescription>{messageDescription}</MessageDescription>
            )}
          </MessageContainer>
        </ToasterLogoContainer>
        {rightComponent ? (
          rightComponent
        ) : (
          <Pressable
            style={{
              alignItems: 'flex-end',
              justifyContent: 'center',
            }}
            onPress={action ? action?.onPress ?? (() => null) : onClosePress}
          >
            {action ? (
              <BTN className="text-primary-100">{action?.text}</BTN>
            ) : (
              props.actionButton ?? (
                <Icon type="CircleCloseOutlined" color={colors.grays[60]} />
              )
            )}
          </Pressable>
        )}
      </ToastContainer>
    </SingleSidedShadowBox>
  )
}
